import { isNil } from 'lodash';
import { DirectLink, NavLinks } from '@/__configs/config_types';
import { defaultLinks } from '@/components/Navbar/Navbar';

export const findFirstAccessibleRoute = (permissions: string[], navLinksConfig?: NavLinks) => {
  const navLinks = navLinksConfig || defaultLinks;

  const link = navLinks.find((link) => {
    if (link.children && link.children.length) {
      const canAccessChildren = !!link.children.find((child: DirectLink) => !!child.role && permissions.includes(child.role));

      if (canAccessChildren) {
        return true;
      }
    }

    return link.role && permissions.includes(link.role);
  });

  if (link && link.children) {
    const accessibleChild = link.children.find((child: any) => permissions.includes(child.role));

    if (accessibleChild) {
      return accessibleChild.to;
    }
  }

  return link?.to;
};

/**
 * Replace existing query params in a URL with values from `updates`.
 * - If a value is null/undefined => the param is removed.
 */
export function replaceQueryParams(updates: Record<string, unknown>, url: string = window.location.href): string {
  const u = new URL(url);
  const sp = u.searchParams;

  Object.entries(updates).forEach(([key, value]) => {
    // remove param if null/undefined
    if (isNil(value)) {
      sp.delete(key);
      return;
    }

    // set value(s)
    sp.delete(key);
    sp.set(key, String(value));
  });

  const path = u.pathname || '';
  const query = sp.toString();
  const hash = u.hash || '';
  return query ? `${path}?${query}${hash}` : `${path}${hash}`;
}
